import AutomationExecutionsAPI from 'dashboard/api/pipelines/automationExecutions';

const state = {
  records: [],
  currentExecution: null,
  meta: { totalCount: 0, currentPage: 1, totalPages: 1 },
  uiFlags: {
    isFetching: false,
    isFetchingDetail: false,
  },
};

export const getters = {
  getExecutions(_state) {
    return _state.records;
  },
  getCurrentExecution(_state) {
    return _state.currentExecution;
  },
  getMeta(_state) {
    return _state.meta;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  index: async ({ commit }, { accountId, params = {} }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await AutomationExecutionsAPI.index(accountId, params);
      commit('SET_ITEMS', response.data?.data || []);
      commit('SET_META', response.data?.meta || {});
    } catch (e) {
      commit('SET_ITEMS', []);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  show: async ({ commit }, { accountId, id }) => {
    commit('SET_UI_FLAG', { isFetchingDetail: true });
    try {
      const response = await AutomationExecutionsAPI.show(accountId, id);
      commit('SET_CURRENT', response.data);
    } catch (e) {
      commit('SET_CURRENT', null);
    } finally {
      commit('SET_UI_FLAG', { isFetchingDetail: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },

  SET_ITEMS(_state, items) {
    _state.records = Array.isArray(items) ? items : [];
  },

  SET_META(_state, meta) {
    _state.meta = {
      totalCount: meta.total_count || 0,
      currentPage: meta.current_page || 1,
      totalPages: meta.total_pages || 1,
    };
  },

  SET_CURRENT(_state, execution) {
    _state.currentExecution = execution;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
